export default {
  circleBg: {
    base: {
      stroke: 'grey-05'
    }
  },
  circleSpin: {
    base: {
      stroke: 'primary'
    }
  }
};